module.exports = __webpack_public_path__ + "static/media/h_blog1.c9cfdaa5.jpg";